/**
 * ForecastSummaryPrint — page « Synthèse » du Prévisionnel.
 * Réutilise le COMPOSANT RÉEL de l'écran (ForecastSummary) : KPI + compte de
 * résultat prévisionnel condensé + cash flow. Les hypothèses BFRE + cash flow
 * sont lues EN BASE (même hook que le hub Prévisionnel) — pas le sessionStorage,
 * sinon le BFRE ne varie pas comme à l'écran. `onReady` (one-shot) → host.
 */
import React, { useRef } from 'react';
import { useTranslation } from 'react-i18next';
import ForecastSummary from '../ForecastSummary';
import { usePersistentValue } from '../../hooks/usePersistentState';
import { useForecastAssumptions } from '../../hooks/useForecastAssumptions';
import PrintReportHeader from '../hr/print/PrintReportHeader';
import '../hr/print/PeoplePrint.css';
import './financialsScreenPrint.css';

const noop = () => {};

export default function ForecastSummaryPrint({ activeTenant, year, editedAt, onDataReady }) {
  const { t } = useTranslation();
  const tid = activeTenant?.id;
  const [unit] = usePersistentValue(`prev_unit_${tid}`, 'kchf');
  const { a, loading: aLoading } = useForecastAssumptions(tid, year);
  const assumptions = { dso: a.dso, dpo: a.dpo, dio: a.dio, pac: a.pac, setDso: noop, setDpo: noop, setDio: noop, setPac: noop };
  const cashflow = { invLines: a.cf_inv, finLines: a.cf_fin, setInvLines: noop, setFinLines: noop };
  const done = useRef(false);
  const ready = () => { if (!done.current) { done.current = true; if (onDataReady) onDataReady('forecast-synthese'); } };

  // On attend les hypothèses (DB) avant de monter le composant → le modèle BFRE
  // se calcule d'emblée sur les bonnes valeurs (comme à l'écran).
  if (aLoading) return <div className="ppl-print__section"><p>Chargement…</p></div>;

  return (
    <section className="ppl-print__section ppl-print__section--wide fin-screenprint">
      <PrintReportHeader category={t('phrases:p_6ac06e4cde')} title={t('phrases:p_027b635ace')} year={year} unit={unit} tenant={activeTenant} editedAt={editedAt} />
      <ForecastSummary activeTenant={activeTenant} year={year} assumptions={assumptions} cashflow={cashflow} unit={unit} onReady={ready} />
    </section>
  );
}
